import Vue from 'vue'
import Router from 'vue-router'
import 'firebase/auth'
import firebase from 'firebase/app'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return {
      x: 0,
      y: 0
    }
  },
  routes: [

    {
      // =============================================================================
      // MAIN LAYOUT ROUTES
      // =============================================================================
      path: '',
      component: () => import('./layouts/main/Main.vue'),
      children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================
        {
          path: '/',
          name: 'home',
          component: () => import('./views/chooseRestaurant.vue')
        },
        {
          path: '/meal',
          name: 'meal',
          component: () => import('./views/chooseMeal.vue')
        },
        {
          path: '/checkout',
          name: 'checkout',
          component: () => import('./views/Checkout.vue'),
        },
        {
          path: '/about',
          name: 'about',
          component: () => import('./views/pages/about.vue')
        },
        {
          path: '/successPayment',
          name: 'success-Payment',
          component: () => import('./views/pages/Success.vue'),
        },
        {
          path: '/order',
          name: 'order-view',
          component: () => import('./views/OrderView.vue'),
        }
      ],
    },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
      path: '',
      component: () => import('@/layouts/full-page/FullPage.vue'),
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================
        {
          path: '/pages/login',
          name: 'page-login',
          component: () => import('@/views/pages/Login.vue')
        },
        {
          path: '/service',
          name: 'serviceunavailble',
          component: () => import('@/views/pages/pleasewait.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/pages/orders',
          name: 'orders-admin',
          component: () => import('@/views/pages/orderPanel.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/pages/error-404',
          name: 'page-error-404',
          component: () => import('@/views/pages/Error404.vue')
        },
      ]
    },
    // Redirect to 404 page, if no match found
    {
      path: '*',
      redirect: '/pages/error-404'
    }
  ],
})

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = "none";
  }
})
router.beforeEach((to, from, next) => {
  firebase.auth().onAuthStateChanged(() => {

    // get firebase current user
    const firebaseCurrentUser = firebase.auth().currentUser

    // If auth required, check login. If login fails redirect to login page
    if (to.meta.authRequired) {
      if (firebaseCurrentUser) {
        router.push({
          path: '/pages/login',
          query: {
            to: to.path
          }
        })
      }
    }

    return next()
    // Specify the current path as the customState parameter, meaning it
    // will be returned to the application after auth
    // auth.login({ target: to.path });

  });

});

export default router